import { render, staticRenderFns } from "./Assignments.vue?vue&type=template&id=2e6e6dab&scoped=true"
import script from "./Assignments.vue?vue&type=script&lang=js"
export * from "./Assignments.vue?vue&type=script&lang=js"
import style0 from "./Assignments.vue?vue&type=style&index=0&id=2e6e6dab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e6e6dab",
  null
  
)

export default component.exports